/**
 * Chốt chặn quảng cáo: quảng cáo chỉ được HIỂN THỊ, không được tự ý điều hướng.
 *
 * Script quảng cáo của bên thứ ba (Adsterra, Smartlink…) chạy ngay trong
 * trang nên có thể tự mở tab mới hoặc đổi địa chỉ trang. Người dùng chỉ muốn
 * xem phim — bị đá sang trang lạ giữa chừng là lý do bỏ web phổ biến nhất,
 * và cũng làm hỏng phiên xem phim (mất tiến trình, phải tải lại player).
 *
 * Nguyên tắc: mọi điều hướng phải bắt nguồn từ một cú click/keypress thật của
 * người dùng. Không có cử chỉ đó thì chặn.
 */

// Cửa sổ coi một cử chỉ là "vừa xảy ra" (ms) — dùng cho trình duyệt cũ
// không hỗ trợ navigator.userActivation.
const GESTURE_WINDOW = 1000;

let lastGestureAt = 0;

function markGesture() {
  lastGestureAt = Date.now();
}

/**
 * Người dùng có vừa thực hiện cử chỉ nào không?
 *
 * Ưu tiên `navigator.userActivation.isActive` — đây là tín hiệu chuẩn của
 * trình duyệt, chỉ bật trong vài giây ngay sau click/keypress thật. Nó phân
 * biệt được click thật với click do script giả lập, thứ mà cách đếm thời gian
 * thủ công không làm được.
 */
function hasUserGesture() {
  if (typeof navigator !== "undefined" && navigator.userActivation) {
    return navigator.userActivation.isActive;
  }

  return Date.now() - lastGestureAt < GESTURE_WINDOW;
}

/**
 * Cài chốt chặn. Gọi một lần, càng sớm càng tốt — trước khi app mount để
 * không script quảng cáo nào kịp chạy trước.
 */
export function installAdGuard() {
  if (typeof window === "undefined") return;

  // Ghi nhận cử chỉ thật của người dùng. Dùng capture để bắt được cả khi
  // component đã stopPropagation.
  ["pointerdown", "mousedown", "touchstart", "keydown"].forEach((eventName) => {
    window.addEventListener(eventName, markGesture, {
      capture: true,
      passive: true,
    });
  });

  const nativeOpen = window.open;

  window.open = function guardedOpen(url, target, features) {
    if (!hasUserGesture()) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("[adGuard] Đã chặn window.open tự động:", url);
      }

      return null;
    }

    return nativeOpen.call(window, url, target, features);
  };
}

/**
 * Sandbox cho iframe quảng cáo.
 *
 * Cố ý KHÔNG có `allow-top-navigation`: đó là token cho phép iframe đổi địa
 * chỉ trang chính bất cứ lúc nào, kể cả khi người dùng không bấm gì — đúng
 * thứ cần chặn.
 *
 * Vẫn giữ `allow-top-navigation-by-user-activation` để quảng cáo click-through
 * hoạt động: người dùng bấm vào quảng cáo thì được phép chuyển trang. Tức là
 * "chỉ chuyển khi người dùng click", đúng yêu cầu.
 */
export const AD_IFRAME_SANDBOX = [
  "allow-scripts",
  "allow-same-origin",
  "allow-popups",
  "allow-popups-to-escape-sandbox",
  "allow-forms",
  "allow-modals",
  "allow-downloads",
  "allow-pointer-lock",
  "allow-presentation",
  "allow-top-navigation-by-user-activation",
].join(" ");

/**
 * Gắn sandbox lên một iframe quảng cáo.
 *
 * Gọi ngay khi iframe được chèn vào DOM. Ở thời điểm đó iframe chưa tải xong
 * nội dung nên việc đặt thuộc tính không làm mất impression nào.
 */
export function hardenAdIframe(iframe) {
  if (!iframe || iframe.nodeName !== "IFRAME") return;

  if (iframe.getAttribute("sandbox") === AD_IFRAME_SANDBOX) return;

  iframe.setAttribute("sandbox", AD_IFRAME_SANDBOX);
}
